import React from 'react';
import { connect } from 'react-redux';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import moment from 'moment';
import { toDateFormat } from 'utils/date';
import Loader from 'features/Loader/Loader';
import { getWorkoutLog } from 'features/clientProfile/components/workoutTab/ducks/clientProfileWorkoutActions';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { getClient } from '../../../ducks/clientProfileActions';

class WorkoutLogDetails extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = props.match.params.client_id;
    this.logId = props.match.params.id;
  }

  componentDidMount = () => {
    let { history } = this.props;
    this.props.getClient(this.clientId, history);
    this.props.getWorkoutLog(this.logId, this.clientId, history);
  };

  arrow = ({ text, className }) => {
    return <div className={className}>{text}</div>;
  };

  prepareExerices = (sets, exerciseIndex) => {
    const ArrowLeft = this.arrow({ text: '<', className: 'arrow-prev' });
    const ArrowRight = this.arrow({ text: '>', className: 'arrow-next' });
    return (
      <ScrollMenu
        wrapperClass="exercise-info"
        wheel={true}
        itemClass="item-style"
        hideArrows={true}
        arrowDisabledClass="arrow-disabled-class"
        data={sets.map((set, index) => {
          return (
            <span key={index}>
              {set.exercises[exerciseIndex].weight}k x{' '}
              {set.exercises[exerciseIndex].reps}r <br /> Set {index + 1}
            </span>
          );
        })}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
      />
    );
  };

  prepareSeriesList = () => {
    let { currentWorkoutLog } = this.props;
    return (
      <div className="workout-series-list workout-log-list">
        <ul>
          {currentWorkoutLog.series.map((seriesElement, index) => {
            return (
              seriesElement.sets && seriesElement.sets[0].exercises.length && (
                <li key={seriesElement.id}>
                  <div className="workout-item">
                    <i className="fas fa-dumbbell"></i>
                    <div className="workout-info">
                      <h4>{seriesElement.series_name}</h4>
                      <p>
                        {!!seriesElement.original_reps
                          ? `${seriesElement.original_reps} reps`
                          : seriesElement.original_method}
                        , {seriesElement.original_sets} sets
                      </p>
                    </div>
                    <ul className="series-details">
                      {seriesElement.sets[0].exercises.map(
                        (exercise, exerciseIndex) => {
                          return (
                            <li className="list-element-margin">
                              {exercise.exercise_name}
                              {this.prepareExerices(
                                seriesElement.sets,
                                exerciseIndex
                              )}
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                </li>
              )
            );
          })}
        </ul>
      </div>
    );
  };

  render() {
    let { client, currentWorkoutLog, loading } = this.props;
    let name = client ? `${client.first_name} ${client.last_name}` : '';

    if (loading) {
      return <Loader />;
    }
    return (
      <div className="workout-details">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}`}>
              {name}
            </Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${this.clientId}/workout-history`}>
              Workout History
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {currentWorkoutLog &&
                `${currentWorkoutLog.name} ${moment(toDateFormat(currentWorkoutLog.created_at)).format('L')}`}
            </Breadcrumb.Item>
          </Breadcrumb>

          <div className="page-title">
            <h4>
              {currentWorkoutLog && currentWorkoutLog.name}
              <span>
                {currentWorkoutLog && currentWorkoutLog.level}
                {currentWorkoutLog &&
                  currentWorkoutLog.phase &&
                  `Phase ${currentWorkoutLog.phase}`}
              </span>
            </h4>
          </div>

          {currentWorkoutLog &&
            currentWorkoutLog.series &&
            this.prepareSeriesList()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loading: state.clientProfileWorkoutReducer.loading,
    currentWorkoutLog: state.clientProfileWorkoutReducer.currentWorkoutLog
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getWorkoutLog: (logId, clientId, history) =>
      dispatch(getWorkoutLog(logId, clientId, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutLogDetails);
